"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setUnreadCountAction = void 0;
const action_type_1 = __importDefault(require("@app/const/action-type"));
const setUnreadCountAction = (unreadCount) => ({
    type: action_type_1.default.SET_CHAT_UNREAD_MESSAGES,
    payload: unreadCount,
});
exports.setUnreadCountAction = setUnreadCountAction;
